module.exports = __webpack_public_path__ + "img/dengnavicon2.99bd4876.png";